import React from 'react';

import { Box, useTheme } from '@mui/material';

import { Main } from 'layouts';
import Container from 'components/Container';
import Hero  from './components/Hero';
import Partners from './components/Partners';
import TestimonialCard from './components/TestimonialCard';
import { useAutoScrollToTop } from 'hooks/useScrollToTop';

import { generateTestimonialsDataStructure, testimonialsES } from './utils';

// using ES as template but it is the same for EN and ES
const testimonials = generateTestimonialsDataStructure(testimonialsES); 

const Testimonials = () => {
  const theme = useTheme();
  useAutoScrollToTop();
  return (
    <React.Fragment>
      <Main>
        <Hero />
        <Box backgroundColor={theme.palette.background.level1} padding={0}>
          <Container
            maxWidth={{ sm: 720, md: 1236, lg: 1440 }}
            display='flex'
            justifyContent='center'
          >
            <Box 
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(330px, 590px))',
                gridRows: '',
                gap: 5,
                width: '100%',
                justifyContent: 'center'
              }}
            >
              {
                testimonials.map((testimonial) => {
                  return (
                    <TestimonialCard testimonial={testimonial} key={crypto.randomUUID()} />
                  );
                })
              }
            </Box>

          </Container>
        </Box>
        <Box bgcolor="primary" paddingTop={1} id={'ally'}>
          <Partners />
        </Box>
      </Main>
    </React.Fragment>
  );
};

export default Testimonials;
